import React from 'react';
import { useTheme } from '../theme/ThemeContext';

const CONTACT_EMAIL = 'novijgod@yahoo.dk';

const iconProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    width: 18,
    height: 18,
    'aria-hidden': true,
};

const MailIcon = () => (
    <svg {...iconProps}>
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
    </svg>
);

const LinkedInIcon = () => (
    <svg {...iconProps}>
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
        <rect x="2" y="9" width="4" height="12" />
        <circle cx="4" cy="4" r="2" />
    </svg>
);

const GitHubIcon = () => (
    <svg {...iconProps}>
        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
    </svg>
);

function Contact() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <section className="section" id="contact">
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label">{isDark ? '# 05. CONNECT' : '05 — Contact'}</span>
          <h2 className="section-header__title">Contact</h2>
          <p className="section-header__subtitle">
            If you're working on hard problems at the intersection of AI and
            systems architecture, I'd like to hear about it.
          </p>
        </div>

        <div className="contact-grid reveal reveal-delay-1">
          {/* Contact info side */}
          <div className="contact-info">
            <h3>Let's talk architecture.</h3>
            <p>
              I'm a B.Sc. Software Development student (graduating 2027) with 4+
              years of production engineering experience, seeking an internship in
              systems or AI engineering — especially teams scaling distributed
              platforms or shipping ML to production. Based in Copenhagen and
              available for on-site, hybrid, or remote work across the EU.
            </p>

            <div className="contact-links">
              <a href={`mailto:${CONTACT_EMAIL}`} className="contact-link">
                <span className="contact-link__icon">
                    <MailIcon />
                </span>
                {CONTACT_EMAIL}
              </a>
              <a
                href="https://www.linkedin.com/in/aleksandr-sorokin-631a24265/"
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="contact-link__icon">
                    <LinkedInIcon />
                </span>
                LinkedIn Profile
              </a>
              <a
                href="https://github.com/jarrald"
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="contact-link__icon">
                    <GitHubIcon />
                </span>
                GitHub
              </a>
            </div>
          </div>

          {/* Contact form side */}
          <div>
            <form
              method="POST"
              name="contact"
              data-netlify="true"
              netlify-honeypot="bot-field"
              netlify
            >
              <input type="hidden" name="form-name" value="contact" />
              <p style={{ display: 'none' }}>
                <label>
                  Don't fill this out: <input name="bot-field" />
                </label>
              </p>

              <div className="input-group">
                <label htmlFor="name">NAME</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="email">EMAIL</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="you@example.com"
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="subject">SUBJECT</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="What's this about?"
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="message">MESSAGE</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Describe the problem, project, or opportunity..."
                  required
                />
              </div>

              <button type="submit" className="btn btn--primary">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;